import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useUrlParams from '../../../../hooks/useUrlParams';



const Title = () => {
  const { t } = useTranslation();
  const {baseUrl} = useUrlParams();

  const url = new URL(baseUrl);
  const id = url.pathname.split('/').pop() || '';
  const adminOrigin = `${url.protocol}//admin.${url.host}`;

  return (
    <Col xs={10} >
      <h2 className='fw-normal mb-0 gap-1 text-dark'>
         {t('booking.title')}
      </h2>
      <div className="d-flex gap-2 text-info">
        <a href={`${adminOrigin}/logbook/journal/${id}`} target="_parent" className='cursor-pointer text-pos-main'>{t('booking.title2')}</a>
        <div className=''><span>></span></div>
        <div className=''>{t('booking.title')}</div>
      </div>
    </Col>
  );
};

export default Title;
